export default "__VITE_ASSET__zErSIc7w__"